import { useState, useEffect } from 'react';
import { usePage } from '../contexts/PageContext.jsx';
import InstrumentSelector from '../components/futures-signals/InstrumentSelector.jsx';
import SubTabBar from '../components/futures-signals/SubTabBar.jsx';
import DashboardTab from '../components/futures-signals/tabs/DashboardTab.jsx';
import SignalsTab from '../components/futures-signals/tabs/SignalsTab.jsx';
import ShadowTraderTab from '../components/futures-signals/tabs/ShadowTraderTab.jsx';
import NewsCalendarTab from '../components/futures-signals/tabs/NewsCalendarTab.jsx';
import SettingsTab from '../components/futures-signals/tabs/SettingsTab.jsx';

const TAB_STORAGE_KEY = 'korinth_futures_tab';

export default function FuturesSignals() {
  const { setPage } = usePage();
  useEffect(() => { setPage('futures-signals'); }, []);
  const [instrument, setInstrument] = useState('NQ');
  const [activeTab, setActiveTab] = useState(() => {
    try { return localStorage.getItem(TAB_STORAGE_KEY) || 'dashboard'; }
    catch { return 'dashboard'; }
  });
  const [shadowPrefill, setShadowPrefill] = useState(null);

  useEffect(() => {
    try { localStorage.setItem(TAB_STORAGE_KEY, activeTab); }
    catch { /* silent */ }
  }, [activeTab]);

  function handleShadowTrade(signal) {
    setShadowPrefill(signal);
    setActiveTab('shadow');
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <h1 className="text-2xl font-bold text-white">Futures Signals</h1>
        <span className="text-korinth-muted text-sm">ICT-based session analysis & OTE entries</span>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <SubTabBar active={activeTab} onChange={setActiveTab} />
        {activeTab !== 'settings' && activeTab !== 'news' && (
          <div className="sm:ml-auto">
            <InstrumentSelector selected={instrument} onSelect={setInstrument} />
          </div>
        )}
      </div>

      {activeTab === 'dashboard' && (
        <DashboardTab instrument={instrument} onShadowTrade={handleShadowTrade} />
      )}
      {activeTab === 'signals' && (
        <SignalsTab instrument={instrument} />
      )}
      {activeTab === 'shadow' && (
        <ShadowTraderTab instrument={instrument} prefillSignal={shadowPrefill} />
      )}
      {activeTab === 'news' && (
        <NewsCalendarTab />
      )}
      {activeTab === 'settings' && (
        <SettingsTab />
      )}
    </div>
  );
}
